import { createSlice } from '@reduxjs/toolkit'

export const instalmentPlan = createSlice({
	name: 'instalmentPayment',
	initialState: {
		client: '',
		imei: '',
		cardCode: '',
	},
	reducers: {
		setClient: (state, action) => {
			state.client = action.payload
		},
		setImei: (state, action) => {
			state.imei = action.payload
		},
		setCardCode: (state, action) => {
			state.cardCode = action.payload
		},
	},
})
